// src/services/axiosConfig.js
import axios from 'axios';
import config from '../config';
import { message } from 'antd';
import { store, persistor } from '../store/auth/store';
import { clearLogout } from '../store/auth/authSlice';

// ————————————————————————————————————————————
// 1) Defaults
axios.defaults.baseURL = config.baseUrl;
axios.defaults.withCredentials = true;

// 2) Rutas que NO llevan token
// 2) Estas rutas NO llevan token
const isAuthRoute = (url = '') =>
    url.endsWith('/api/auth/login') ||
    url.endsWith('/api/auth/refresh') ||
    url.endsWith('/api/auth/logout');   // <-- añadimos el logout aquí

// 3) Request interceptor: añade el Bearer token
axios.interceptors.request.use(cfg => {
    if (!isAuthRoute(cfg.url)) {
        const token = store.getState().auth.user?.token;

        if (token) cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
}, err => Promise.reject(err));

// 4) Response interceptor: si 401 → forza logout
axios.interceptors.response.use(
    res => res,
    async err => {
        const status = err.response?.status;
        const url = err.config?.url || '';
        const hasAuth = Boolean(err.config?.headers?.Authorization);

        if (status === 401 && !isAuthRoute(url) && hasAuth) {
            message.warning('Tu sesión ha expirado o fue cerrada en otro dispositivo.', 3);
            // limpia cookie backend
            try { await axios.post('/api/auth/logout'); } catch (_) { }

            // limpia estado
            await persistor.purge();
            store.dispatch(clearLogout());
            localStorage.clear();

            // notificamos al modal sin recargar la página
            window.dispatchEvent(new Event('force-logout'));
        }
        return Promise.reject(err);
    }
);

// 5) Para que cualquier axios.create herede los mismos interceptores
const originalCreate = axios.create.bind(axios);
axios.create = cfg => {
    const instance = originalCreate(cfg);
    // copiar defaults
    instance.defaults.baseURL = axios.defaults.baseURL;
    instance.defaults.withCredentials = axios.defaults.withCredentials;
    // copiar interceptores request
    axios.interceptors.request.handlers.forEach(h =>
        instance.interceptors.request.use(h.fulfilled, h.rejected)
    );
    // copiar interceptores response
    axios.interceptors.response.handlers.forEach(h =>
        instance.interceptors.response.use(h.fulfilled, h.rejected)
    );
    return instance;
};
